import http from "../../axios-config/g-http-metodos";

function getCidadesByEstado(estadoId){
    const { res, erro, requisicao } = http.post('Cidade/getbyestado', {id: estadoId})
    return { CidadeArray: res, erro, requisicao }
}

function getByCidadeEstado(FiltroNome, estadoId){
    const { res, erro, requisicao } =  http.post(`Cidade/getByCidadeEstado/${FiltroNome}/${estadoId}`)
    return { CidadeArray: res, erro, requisicao }
}

function getCidadesAtivas(){
    const { res, erro, requisicao } =  http.getArray('cidade/GetCidadesAtivas')
    return { CidadeArray: res, erro, requisicao }
}

function GetCidadeTipoFrete(estadoId, cidadeId) {
    const { res, erro, requisicao } = http.getArray(`Cidade/GetCidadeTipoFrete${estadoId ? '/' + estadoId: ''}${cidadeId ? '/' + cidadeId: ''}`);
    return { res, erro, requisicao };
}

function AtualizaTipoFreteCidade(cidadeId, ehFechado, ehFracionado){
    const { res, erro, requisicao } = http.post(`Cidade/AtualizaTipoFreteCidade/${cidadeId}/${ehFechado}/${ehFracionado}`);
    return { res, erro, requisicao };

}

const CidadeController = {
    getByCidadeEstado,
    getCidadesByEstado,
    GetCidadeTipoFrete,
    getCidadesAtivas,
    AtualizaTipoFreteCidade
}

export default CidadeController
